module.exports = "\n<app-loader></app-loader>\n\n<router-outlet></router-outlet>\n"